<template>
	<modal
		class="products-adaptation-modal"
		:modalOpen="modalOpen"
		ref="modalContainer"
		@close="$emit('close')"
		id="products-adaptation-modal"
	>
		<div class="header display-1 mobile-headline-6" slot="header">Adaptation to your experiment required</div>
		<div class="subHeader body-1" slot="subHeader">Selected product requires additional products.</div>
		<div class="content">
			<div v-if="addProducts.length" class="products-column add-column">
				<h6 class="H5-5 mobile-hide">The following products will be added:</h6>
				<h6 class="desktop-hide mobile-headline-6">Will be added:</h6>
				<div class="desktop-hide mobile-scroll" @click="scrollLeft">
					<span> <base-icon class="nav_icon" icon-name="chevron-right" icon-size="16px" /></span>
				</div>
				<div class="p-list">
					<div class="p-list-item" v-for="(prod, i) in addProducts" :key="i">
						<base-image
							:src="{image: prod.image, mobileImage: prod.mobileImage}"
							:alt="getName(prod.name)"
						/>
						<div class="p-info">
							<p class="caption-2 product-title">
								<a :href="prod.pageLink" target="_blank" v-html="getName(prod.name)"></a>
							</p>
							<p class="overline">Cat. No. {{ prod.catalogNumber }}</p>
						</div>
					</div>
				</div>
			</div>
			<div v-if="removeProducts.length" class="products-column remove-column">
				<h6 class="p-header H5-5 mobile-headline-6">Will be removed:</h6>
				<div class="desktop-hide mobile-scroll" @click="scrollLeft">
					<span> <base-icon class="nav_icon" icon-name="chevron-right" icon-size="16px" /> </span>
				</div>
				<div class="p-list">
					<div class="p-list-item" v-for="(prod, i) in removeProducts" :key="i">
						<base-image
							:src="{image: prod.image, mobileImage: prod.mobileImage}"
							:alt="getName(prod.name)"
						/>
						<div class="p-info">
							<p class="caption-2 product-title">
								<a :href="prod.pageLink" target="_blank" v-html="getName(prod.name)"></a>
							</p>
							<p class="overline">Cat. No. {{ prod.catalogNumber }}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="footer" slot="footer">
			<md-button class="md-primary md-button-large customProduct--cancel" @click.stop="$emit('close')">
				Cancel
			</md-button>
			<md-button class="md-primary md-raised md-button-large has-icon apply-product" @click="$emit('accept')">
				Accept
			</md-button>
		</div>
	</modal>
</template>

<script>
import BaseImage from '@/shared/base-img';

export default {
	components: {
		BaseImage,
	},

	name: 'ProductsAdaptationModal',
	props: {
		modalOpen: {
			type: Boolean,
		},
		removeProducts: {
			type: Array,
		},
		addProducts: {
			type: Array,
		},
	},
	methods: {
		scrollLeft(e) {
			e.target.nextElementSibling.scrollLeft += 320;
			this.$emit('scrollProducts');
		},
		getName(name) {
			return name[this.$store.state.LANG];
		},
	},
};
</script>

<style lang="scss" scoped>
.products-adaptation-modal {
	::v-deep {
		.modal-container {
			@media (min-width: $mobile+1) {
				> .header {
					padding-bottom: 8px;
				}
				> .subHeader {
					margin-bottom: 58px;
				}
				width: 866px;
				max-width: 866px;
				max-height: 773px;
			}
			@media (max-width: $mobile) {
				> .header {
					padding-bottom: 0;
				}
				> .subHeader {
					margin-bottom: 36px;
				}
				width: 100%;
				min-width: unset;
				overflow: unset;
				// max-height: none;
			}
		}
	}

	.content {
		@include flexRow;
		position: relative;
		max-height: 500px;

		label {
			position: absolute;
			left: 12px;
			top: -10px;
			padding: 0 2px;
			background-color: white;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
		textarea {
			border: 1px solid $color-grey;
			border-radius: 10px;
			min-height: 108px;
			padding: 10px 12px;
			&:focus,
			&:active {
				outline: none;
			}
		}
		span.md-count {
			height: 20px;
			font-size: 12px;
			transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
			text-align: end;
			margin-top: 4px;
		}
		.products-column {
			flex: 1;
			display: flex;
			flex-direction: column;
			max-width: 65%;
			padding-right: 40px;
			&.remove-column {
				a {
					color: $color-grey;
				}
				::v-deep {
					img {
						filter: grayscale(1);
					}
				}
			}
		}
		.p-header {
			flex: 1;
		}
		.p-list {
			overflow-y: scroll;

			&::-webkit-scrollbar {
				width: 8px;
				height: 5px;
				background-color: white;
			}
			&::-webkit-scrollbar-thumb {
				background: #bcbcbb;
				border-radius: 5px;
			}
		}
		.p-list-item {
			@include flexRow;
			margin: 2rem 0;
			padding-right: 12px;
			div {
				flex: 1;
				&:first-of-type {
					max-width: 144px;
				}
			}
		}
		.p-info {
			margin-left: 24px;
			p {
				margin: 0;
				color: $color-grey;
			}
		}
		@media (max-width: $mobile) {
			display: flex;
			flex-direction: column;
			overflow-y: scroll;
			.products-column {
				max-width: 100%;
				padding: 0;
				position: relative;
				.mobile-scroll {
					position: absolute;
					z-index: 1;
					bottom: 0;
					right: 0;
					width: 40px;
					height: 65%;
					display: flex;
					justify-content: center;
					align-items: center;
					background: linear-gradient(270deg, white, transparent);
					> * {
						pointer-events: none;
						color: $color-blue;
					}
				}

				.p-list {
					display: flex;
					overflow-x: scroll;
					scroll-behavior: smooth;
					&::-webkit-scrollbar {
						display: none;
					}
					.p-list-item {
						width: 320px;
						min-width: 320px;
						flex-shrink: 0;
						margin: 12px 0 20px;
						div:first-of-type {
							max-width: 108px;
							min-width: 108px;
						}
					}
				}
			}
		}
	}

	.footer {
		@include flexRow;
		justify-content: flex-end;
		width: 100%;
		button:nth-child(1) {
			margin-right: 8px;
		}
	}
	.column {
		display: flex;
		justify-content: space-between;
	}
}
</style>
